export type DictionarySearchMatch = {
  match: boolean;
  score: number;
  relevance: number;
};

export function fuzzyDictionarySearch(
  needle: string,
  haystack: string,
): DictionarySearchMatch {
  const normalizedNeedle = needle.toLowerCase();
  const normalizedHaystack = haystack.toLowerCase();

  if (normalizedHaystack.includes(normalizedNeedle)) {
    return {
      match: true,
      score: 1,
      relevance: normalizedNeedle.length / normalizedHaystack.length,
    };
  }

  let needleIdx = 0;
  let haystackIdx = 0;
  let score = 0;

  while (
    needleIdx < normalizedNeedle.length &&
    haystackIdx < normalizedHaystack.length
  ) {
    if (normalizedNeedle[needleIdx] === normalizedHaystack[haystackIdx]) {
      score += 1;
      needleIdx += 1;
    }
    haystackIdx += 1;
  }

  if (needleIdx === normalizedNeedle.length) {
    return {
      match: true,
      score: score / normalizedNeedle.length,
      relevance: score / normalizedHaystack.length,
    };
  }

  return { match: false, score: 0, relevance: 0 };
}
